// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3067) return "static/chunks/3067.3aa6f21dc38d3ea5.js";
	if (chunkId === 5231) return "static/chunks/5231.c6262e0eff54b722.js";
	if (chunkId === 1479) return "static/chunks/1479.7066efaaf8fee650.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2537":"4cdf4c346ea00efc","2547":"141a49b0f54bf3af","4694":"3f3f8bf41e6d8877","6591":"e5c1f0f755525cff","8480":"132d5a4f7cdc1e66","9552":"f020e9f69c73fd29","9647":"874a8966b6704bd2"}[chunkId] + ".js";
};